// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__N0j2K","header":"style_header__Xmo0x","snackcontent":"style_snackcontent__ICxfs","body":"style_body__cT5-k"};